document.querySelectorAll('.ba-carousel-wrap').forEach(function (wrap) {
  var track = wrap.querySelector('[data-ba-track]');
  var prevBtn = wrap.querySelector('[data-ba-prev]');
  var nextBtn = wrap.querySelector('[data-ba-next]');

  if (!track || !prevBtn || !nextBtn) return;

  function scrollAmount() {
    var card = track.querySelector('.ba-card');
    if (!card) return 320;
    var style = getComputedStyle(track);
    var gap = parseInt(style.gap || style.columnGap || '24', 10) || 24;
    return card.getBoundingClientRect().width + gap;
  }

  prevBtn.addEventListener('click', function () {
    track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', function () {
    track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
  });
});